enum TranslationNamespace {
  Home = 'CreatorDashboard.Home',
  RoadMap = 'CreatorDashboard.RoadMap',
  Features = 'CreatorDashboard.Features',
  Landing = 'CreatorDashboard.Landing',
  Navigation = 'CreatorDashboard.Navigation',
  Metadata = 'CreatorDashboard.Metadata',
  LogIn = 'CreatorDashboard.LogIn',
  SignUp = 'CreatorDashboard.SignUp',
  DevEx = 'CreatorDashboard.DevEx',
  Controls = 'CreatorDashboard.Controls',
  Error = 'CreatorDashboard.Error',
  Creations = 'CreatorDashboard.Creations',
  AgreementsManager = 'CreatorDashboard.AgreementsManager',
  AssetTypes = 'CreatorDashboard.AssetTypes',
  DevStatsGame = 'CreatorDashboard.DevStatsGame',
  DevStatsExport = 'CreatorDashboard.DevStatsExport',
  DevStatsPremium = 'CreatorDashboard.EngagementPayout',
  DeveloperQuestionnaire = 'CreatorDashboard.DeveloperQuestionnaire',
  Analytics = 'CreatorDashboard.Analytics',
  ExperienceAlerts = 'CreatorDashboard.ExperienceAlerts',
  ImmersiveAdsAnalytics = 'CreatorDashboard.ImmersiveAdsAnalytics',
  Insights = 'CreatorDashboard.Insights',
  AvatarAnalytics = 'CreatorDashboard.AvatarAnalytics',
  StoreAnalytics = 'CreatorDashboard.StoreAnalytics',
  ShareLinkAnalytics = 'CreatorDashboard.ShareLinkAnalytics',
  ComputeTelemetry = 'CreatorDashboard.ComputeTelemetry',
  GameLocalization = 'CreatorDashboard.GameLocalization',
  GameLocalizationLanguages = 'CreatorDashboard.GameLocalizationLanguages',
  GameLocalizationReports = 'CreatorDashboard.GameLocalizationReports',
  GameLocalizationSettings = 'CreatorDashboard.GameLocalizationSettings',
  GameLocalizationTranslators = 'CreatorDashboard.GameLocalizationTranslators',
  GameLocalizationTableManagement = 'CreatorDashboard.GameLocalizationTableManagement',
  GameTranslation = 'CreatorDashboard.GameTranslation',
  GameInfoTranslation = 'CreatorDashboard.GameInfoTranslation',
  GameStringTranslation = 'CreatorDashboard.GameStringTranslation',
  GameProductTranslation = 'CreatorDashboard.GameProductTranslation',
  ConfigureItem = 'CreatorDashboard.ConfigureItem',
  OpenCloud = 'CreatorDashboard.OpenCloud',
  OAuth = 'CreatorDashboard.OAuth',
  ScopeSystem = 'CreatorDashboard.ScopeSystem',
  AgreementsUpdate = 'CreatorDashboard.AgreementsUpdate',
  AssetAnalytics = 'CreatorDashboard.AssetAnalytics',
  UniverseConfigAndExperimentation = 'CreatorDashboard.UniverseConfigAndExperimentation',
  Table = 'CreatorDashboard.Table',
  TranslatorPortal = 'CreatorDashboard.TranslatorPortal',
  Badges = 'CreatorDashboard.Badges',
  DeveloperProducts = 'CreatorDashboard.DeveloperProducts',
  SocialLinks = 'CreatorDashboard.SocialLinks',
  Updates = 'CreatorDashboard.Updates',
  Places = 'CreatorDashboard.Places',
  PlaceThumbnails = 'CreatorDashboard.PlaceThumbnails',
  GenreType = 'CreatorDashboard.GenreType',
  AssetUpload = 'CreatorDashboard.AssetUpload',
  AssetPermissions = 'CreatorDashboard.AssetPermissions',
  Access = 'CreatorDashboard.Access',
  Secrets = 'CreatorDashboard.Secrets',
  PlaceAccess = 'CreatorDashboard.PlaceAccess',
  Passes = 'CreatorDashboard.Passes',
  ActivityFeed = 'CreatorDashboard.ActivityFeed',
  VersionHistory = 'CreatorDashboard.VersionHistory',
  Notifications = 'CreatorDashboard.Notifications',
  DeveloperItem = 'CreatorDashboard.DeveloperItem',
  Settings = 'CreatorDashboard.Settings',
  SendrNotificationPreferences = 'Notifications.Preferences',
  CloudServices = 'CreatorDashboard.CloudServices',
  Community = 'CreatorDashboard.Community',
  Preferences = 'CreatorDashboard.Preferences',
  ExperienceSubscriptions = 'CreatorDashboard.DeveloperSubscriptions',
  Commerce = 'CreatorDashboard.Commerce',
  CreatorAccount = 'CreatorDashboard.CreatorAccount',
  Advanced = 'CreatorDashboard.Advanced',
  RightsPortal = 'CreatorDashboard.RightsPortal',
  Transactions = 'CreatorDashboard.Transactions',
  DataCollection = 'CreatorDashboard.DataCollection',
  DataCollectionSettings = 'CreatorDashboard.DataCollectionSettings',
  DataCollectionTerms = 'CreatorDashboard.DataCollectionTerms',
  MarketplaceOnboarding = 'CreatorDashboard.MarketplaceOnboarding',
  Organization = 'CreatorDashboard.Organization',
  CommunicationSettings = 'CreatorDashboard.CommunicationSettings',
  UnifiedNavigation = 'CreatorDocumentation.Navigation',
  DeveloperLanding = 'CreatorDashboard.DeveloperLanding',
  Payouts = 'CreatorDashboard.Payouts',
  DataSharingSettingsV2 = 'CreatorDashboard.DataSharingSettingsV2',
  PriceOptimization = 'CreatorDashboard.PriceOptimization',
  SafetyControls = 'CreatorDashboard.SafetyControls',
  ShareLinksManagement = 'CreatorDashboard.ShareLinksManagament',
  ShareLinkPromo = 'CreatorDashboard.ShareLinkPromo',
  FiatPaidAccess = 'CreatorDashboard.FiatPaidAccess',
  PublicPublish = 'CreatorDashboard.PublicReach',
  Genres = 'Experience.Genre',
  OwnershipTransfer = 'CreatorDashboard.OwnershipTransfer',
  DocsAssistant = 'Feature.QNAB',
  AssetPrivacy = 'CreatorDashboard.AssetPrivacy',
  AffiliateProgram = 'CreatorDashboard.AffiliateProgram',
  PlayerFeedback = 'CreatorDashboard.PlayerFeedback',
  RegionalPricing = 'CreatorDashboard.RegionalPricing',
  AnalyticsAssistant = 'CreatorDashboard.AnalyticsAssistant',
  Matchmaking = 'CreatorDashboard.CustomMatchmaking',
  Licenses = 'CreatorDashboard.Licenses',
  Permissions = 'CreatorDashboard.Permissions',
  ReferralRewards = 'CreatorDashboard.ReferralRewards',
  DynamicPriceCheck = 'CreatorDashboard.DynamicPriceCheck',
  NotApproved = 'Feature.NotApproved',
  Moderation = 'Feature.Moderation',
  AppealsPortal = 'Feature.AppealsPortal',
  DashboardModeration = 'CreatorDashboard.Moderation',
  Environments = 'CreatorDashboard.Environments',
  PageTitles = 'CreatorDashboard.PageTitles',
  CreatorRewards = 'CreatorDashboard.CreatorRewards',
  CreatorRewardsLanding = 'CreatorDashboard.CreatorRewardsLanding',
  ExperienceReleases = 'CreatorDashboard.ExperienceReleases',
  Variants = 'CreatorDashboard.Variants',
  ServerManagement = 'CreatorDashboard.ServerManagement',
  Safety = 'CreatorDashboard.Safety',
  CommonUIControls = 'CommonUI.Controls',
  Taxonomy = 'CreatorDashboard.Taxonomy',
  RecommendationService = 'CreatorDashboard.RecommendationService',
  DataStoresManager = 'CreatorDashboard.DataStoresManager',
  AccessPolicy = 'CreatorDashboard.AccessPolicy',
  Groups = 'Feature.Groups',
  Privacy = 'Feature.Privacy',
  ManagedPricing = 'CreatorDashboard.ManagedPricing',
  HardCodedPrices = 'CreatorDashboard.HardCodedPrices',
  SocialLinksAgeVerificationUpsell = 'Feature.SocialLinks',
  PurchaseError = 'IAPExperience.PurchaseError',
}

export default TranslationNamespace;
